@if (component) {
<div class="flex p-t-8 p-b-8 wrap row-accordion-component"
     [class.flex-column]="isAccordion">
    <!-- main sections -->
    @for (column of component.columns; track column; let i = $index) {
    <div [ngClass]="'flex-span-' + column.size">
        <!-- header -->
        <h6 class="fs-6 fw-bold"
            [ngClass]="isAccordion ? 'b-b b-col-w p-b' : ''"
            [toggleClass]="'is-open'"
            [toggle]="['rowAccordion' + uid , i]"
            [toggleOff]="!isAccordion"
            *iCms="'heading' of column">
        </h6>
        <!-- content -->
        <div class="p-t"
             [ngClass]="isAccordion ? 'p-t-2 p-b-2 b-b' : ''"
             [hideUp]="['rowAccordion' + uid, i]"
             [open]="!isAccordion">
            <icms-outlet [components]="column.components" />
        </div>
    </div>
    }
</div>
}